// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';
import {
  BULK_APPROVE_ERROR_MESSAGES,
  VALIDATION_OUTCOME,
  EXTRACTION_FETCH_CONCURRENCY
} from '../documentCheckerConstants';

const getErrorMessage = 'Could not get data';
const submitErrorMessage = 'Failed to Submit';

export const documentCheckerActions = {
  GET_DOCUMENT_CHECKER_DATA: 'GET_DOCUMENT_CHECKER_DATA',
  SET_DOCUMENT_CHECKER_DATA: 'SET_DOCUMENT_CHECKER_DATA',
  GET_FILTERS_DATA: 'GET_FILTERS_DATA',
  SET_FILTERS_DATA: 'SET_FILTERS_DATA',
  SET_LOADING_DATA: 'SET_LOADING_DATA',
  SET_CLIENT_FILTER_DATA: 'SET_CLIENT_FILTER_DATA',
  UPDATE_CONSIGNMENT_BY_INDEX: 'UPDATE_CONSIGNMENT_BY_INDEX',
  FETCH_EXTRACTION_RESULT_REQUEST: 'FETCH_EXTRACTION_RESULT_REQUEST',
  FETCH_EXTRACTION_RESULT_SUCCESS: 'FETCH_EXTRACTION_RESULT_SUCCESS',
  FETCH_EXTRACTION_RESULT_FAILURE: 'FETCH_EXTRACTION_RESULT_FAILURE',
  BULK_APPROVE_REQUEST: 'BULK_APPROVE_REQUEST',
  BULK_APPROVE_SUCCESS: 'BULK_APPROVE_SUCCESS',
  BULK_APPROVE_FAILURE: 'BULK_APPROVE_FAILURE'
};

export const updateConsignmentByIndex = payload => ({
  type: documentCheckerActions.UPDATE_CONSIGNMENT_BY_INDEX,
  payload
});

export const getFiltersData = payload => ({
  type: documentCheckerActions.GET_FILTERS_DATA,
  payload
});

export const setFiltersData = payload => ({
  type: documentCheckerActions.SET_FILTERS_DATA,
  payload
});

export const getDocumentCheckerDataAction = payload => ({
  type: documentCheckerActions.GET_DOCUMENT_CHECKER_DATA,
  payload
});

export const setDocumentCheckerDataAction = payload => ({
  type: documentCheckerActions.SET_DOCUMENT_CHECKER_DATA,
  payload
});

export const setLoadingData = payload => ({
  type: documentCheckerActions.SET_DOCUMENT_CHECKER_DATA,
  payload
});

export const setClientFilter = payload => ({
  type: documentCheckerActions.SET_CLIENT_FILTER_DATA,
  payload
});

const removeToastr = () => {
  toastr.removeByType('error');
  toastr.removeByType('warning');
  toastr.removeByType('light');
};

const toastrOptions = {
  timeOut: 0
};

export const getConsignmentDetails = data => dispatch => {
  dispatch(
    getDocumentCheckerDataAction({
      isLoading: true,
      isLoaded: false,
      consignmentData: [],
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDocumentCheckerDocuments',
    method: 'POST',
    data,
    pathVariables: [{ key: 'docType', val: 'POD' }],

    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (res.errorMessage) {
          dispatch(
            getDocumentCheckerDataAction({
              isLoading: false,
              isLoaded: true,
              consignmentData: [],
              error: res.errorMessage
            })
          );
        } else {
          let updatedConsignments = [];
          if (res && res.payload && res.payload.documentConfigurationData) {
            updatedConsignments = [...res.payload.documentConfigurationData];
          }
          updatedConsignments.map(consignment => {
            consignment.displayAddRemarksBox = false;
          });
          dispatch(
            getDocumentCheckerDataAction({
              isLoading: false,
              isLoaded: true,
              consignmentData: updatedConsignments,
              error: null
            })
          );
        }
        removeToastr();
        toastr.success('Success', `Details Fetched Sucessfully`);
        if (
          res &&
          res.payload &&
          res.payload.documentConfigurationData &&
          data &&
          data.cnotes &&
          res.payload.documentConfigurationData.length < data.cnotes.length
        ) {
          toastr.light(
            'Warning',
            'Some entered CN(s) are not eligible for POD Document Checker',
            {
              status: 'warning',
              timeOut: 0
            }
          );
        }
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDocumentCheckerDataAction({
            isLoading: false,
            isLoaded: true,
            consignmentData: [],
            error: res.errorMessage || getErrorMessage
          })
        );
        removeToastr();
        toastr.error(
          'Error',
          'Failed to fetch Consignment Details',
          toastrOptions
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDocumentCheckerDataAction({
          isLoading: false,
          isLoaded: true,
          consignmentData: [],
          error: res.errorMessage || getErrorMessage
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        'Failed to fetch Consignment Details',
        toastrOptions
      );
    },
    catchCb: res => {
      dispatch(
        getDocumentCheckerDataAction({
          isLoading: false,
          isLoaded: true,
          consignmentData: {},
          error: 'Failed to fetch Consignment Details'
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        'Failed to fetch Consignment Details',
        toastrOptions
      );
    }
  };

  return makeApiCall(requestObj);
};

export const updateConsignment = (consignmentIndx, consignment) => dispatch => {
  dispatch(
    updateConsignmentByIndex({
      index: consignmentIndx,
      consignment
    })
  );
};

export const getAllFilters = (apiToUseForClientFilter, userId) => dispatch => {
  dispatch(
    getFiltersData({
      isLoading: true,
      isLoaded: false,
      consignmentData: [],
      filterData: [],
      error: null
    })
  );

  Promise.all([
    getDocumentCheckerFilters()
    // getClientsListFilter(apiToUseForClientFilter, userId)
  ])
    .then(values => {
      dispatch(
        setLoadingData({
          isLoading: false,
          isLoaded: true,
          error: null
        })
      );

      if (values.length > 0) {
        if (values[0].status === 'SUCCESS') {
          dispatch(getFiltersData({ filterData: values[0].payload }));
          removeToastr();
        } else if (values[0].status === 'FAILURE') {
          dispatch(
            getFiltersData({
              consignmentData: [],
              filterData: [],
              error: values[0].errorMessage || getErrorMessage
            })
          );
          removeToastr();
          toastr.error(
            'Error',
            'Failed to fetch Filters Details',
            toastrOptions
          );
        } else {
          dispatch(
            getFiltersData({
              error: getErrorMessage
            })
          );
        }
      }
    })
    .catch(() => {
      dispatch(
        setFiltersData({
          isLoading: false,
          isLoaded: true,
          consignmentData: [],
          filterData: [],
          clientFilterData: [],
          error: getErrorMessage
        })
      );
      dispatch(setClientFilter([]));
      removeToastr();
      toastr.error('Error', 'Failed to fetch Filters Details', toastrOptions);
    });
};

const getDocumentCheckerFilters = dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDocumentcheckerFilters',
    method: 'GET',
    pathVariables: [{ key: 'docType', val: 'POD' }]
  };

  return makeApiCall(requestObj);
};

export const getClientsFilter = searchString => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClients',
    replaceParamsArr: [
      { key: 'searchString', val: encodeURIComponent(searchString) || '' }
    ]
  };

  makeApiCall(requestObj)
    .then(res => {
      if (res.status === 'SUCCESS') {
        const responseList = res.payload || [];
        dispatch(setClientFilter({ clientFilterData: responseList }));
      } else if (res.status === 'FAILURE') {
        dispatch(setClientFilter([]));
      } else {
        dispatch(setClientFilter([]));
      }
    })
    .catch(() => {
      dispatch(setClientFilter([]));
      removeToastr();
    });
};

export const approveORAddRemarksConsignment = (
  data,
  callback,
  consignment,
  consignmentIndx
) => dispatch => {
  dispatch(
    setLoadingData({
      isLoading: true,
      isLoaded: false,
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'consignmentDocumentChecker',
    method: 'PUT',
    replaceParamsArr: [
      { key: 'docType', val: data.docType },
      { key: 'cnote', val: data.cnote },
      { key: 'documentFileIds', val: data.documentFileIds }
    ],
    data: data.data,

    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          setLoadingData({
            isLoading: false,
            isLoaded: true,
            error: null
          })
        );
        const updatedConsignment = { ...consignment };
        updatedConsignment.actionTaken = data.data.actionTaken;
        updatedConsignment.displayAddRemarksBox = false;
        dispatch(
          updateConsignmentByIndex({
            consignment: updatedConsignment,
            index: consignmentIndx
          })
        );
        if (callback) {
          callback();
        }
        removeToastr();
        toastr.success('Success', `Successfully submitted`);
      } else if (res.status === 'FAILURE') {
        dispatch(
          setLoadingData({
            isLoading: false,
            isLoaded: true,
            error: null
          })
        );
        removeToastr();
        toastr.error(
          'Error',
          res.errorMessage || submitErrorMessage,
          toastrOptions
        );
      }
    },
    failureCb: res => {
      dispatch(
        setLoadingData({
          isLoading: false,
          isLoaded: true,
          error: res.errorMessage || submitErrorMessage
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        res.errorMessage || submitErrorMessage,
        toastrOptions
      );
    },
    catchCb: res => {
      dispatch(
        setLoadingData({
          isLoading: false,
          isLoaded: true,
          error: res.errorMessage || submitErrorMessage
        })
      );
      removeToastr();
      toastr.error(
        'Error',
        res.errorMessage || submitErrorMessage,
        toastrOptions
      );
    }
  };

  return makeApiCall(requestObj);
};

export const fetchExtractionResult = (cnote, signal) => dispatch => {
  dispatch({
    type: documentCheckerActions.FETCH_EXTRACTION_RESULT_REQUEST,
    meta: { cnote }
  });
  return makeApiCall({
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'fetchExtractionResult',
    method: 'GET',
    pathVariables: [{ key: '{cnote}', val: cnote }],
    signal,
    notShowPopupOnError: true,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch({
          type: documentCheckerActions.FETCH_EXTRACTION_RESULT_SUCCESS,
          payload: res.payload,
          meta: { cnote }
        });
      } else {
        dispatch({
          type: documentCheckerActions.FETCH_EXTRACTION_RESULT_FAILURE,
          payload: res.errorMessage,
          meta: { cnote }
        });
      }
    },
    failureCb: () =>
      dispatch({
        type: documentCheckerActions.FETCH_EXTRACTION_RESULT_FAILURE,
        payload: 'Could not load AI extraction',
        meta: { cnote }
      }),
    catchCb: () =>
      dispatch({
        type: documentCheckerActions.FETCH_EXTRACTION_RESULT_FAILURE,
        payload: 'Could not load AI extraction',
        meta: { cnote }
      })
  });
};

// makeApiCall returns without dispatching — and without calling any callback — when it bails out
// early, e.g. the bearer-token mismatch confirm that the user can cancel. The wrapping promise would
// then never settle, leaving Promise.all pending and the Approving… button stuck until a reload.
const settleIfNoRequestSent = (call, settle) => {
  if (!call || typeof call.then !== 'function') {
    settle();
  }
};

// Fetch the latest extraction for one cnote. Resolves (never rejects) with the
// PodExtractionResponseDTO payload, or null when there is no extraction (e.g.
// ZBPOD0020 for a pre-AI POD) or on any error. notShowPopupOnError keeps those
// normal misses from firing the global error popup.
const fetchExtractionForCnote = cnote =>
  new Promise(resolve => {
    settleIfNoRequestSent(
      makeApiCall({
        baseUrl: 'zoomApiUrl',
        apiEndPoint: 'fetchExtractionResult',
        method: 'GET',
        pathVariables: [{ key: '{cnote}', val: cnote }],
        notShowPopupOnError: true,
        successCb: res =>
          resolve(res.status === 'SUCCESS' ? res.payload : null),
        failureCb: () => resolve(null),
        catchCb: () => resolve(null)
      }),
      () => resolve(null)
    );
  });

// Run `task` over `items` at most `limit` at a time, preserving order — so a
// large result page doesn't fire one extraction request per row all at once.
const mapWithConcurrency = (items, limit, task) => {
  const results = new Array(items.length);
  let cursor = 0;
  const worker = () => {
    if (cursor >= items.length) return Promise.resolve();
    const current = cursor;
    cursor += 1;
    return Promise.resolve(task(items[current], current)).then(r => {
      results[current] = r;
      return worker();
    });
  };
  const workers = [];
  for (let i = 0; i < Math.min(limit, items.length); i += 1) {
    workers.push(worker());
  }
  return Promise.all(workers).then(() => results);
};

// Approve a single extraction id. Resolves (never rejects) with the outcome so
// the caller can aggregate a best-effort result. notShowPopupOnError keeps a
// skipped POD (ZBPOD0022 / ZBPOD0021) from firing the global error popup.
// Response<T> exposes errorDetails[], not errorCode — reading res.errorCode always gave undefined,
// so every curated message below fell through to the generic one.
const errorCodeOf = res =>
  (res &&
    res.errorDetails &&
    res.errorDetails[0] &&
    res.errorDetails[0].code) ||
  undefined;

const approveOneExtraction = id =>
  new Promise(resolve => {
    settleIfNoRequestSent(
      makeApiCall({
        baseUrl: 'zoomApiUrl',
        apiEndPoint: 'bulkApprovePod',
        method: 'PUT',
        data: { extractionResultIds: [id] },
        notShowPopupOnError: true,
        successCb: res =>
          resolve({
            id,
            ok: res.status === 'SUCCESS',
            errorCode: errorCodeOf(res)
          }),
        failureCb: res =>
          resolve({ id, ok: false, errorCode: errorCodeOf(res) }),
        catchCb: () => resolve({ id, ok: false })
      }),
      () => resolve({ id, ok: false })
    );
  });

// Bulk approve, entirely client-side (no backend contract change needed):
//   1. The list rows (DocumentConfigDto) carry no extraction fields, so fetch
//      each visible POD's extraction and keep the ACCEPTED ones at/above the
//      high-confidence threshold.
//   2. Submit those one extraction id per request and aggregate, rather than as
//      one atomic batch. The backend rejects the whole batch if ANY POD is
//      outside the reviewer's mapped OUs (ZBPOD0022) or ineligible (ZBPOD0021);
//      per-id submission means one bad POD can no longer block the rest, and the
//      reviewer gets an "N approved, M skipped" result instead of a blanket
//      failure with no way to proceed.
export const bulkApproveHighConfidence = (rows, threshold, cb) => dispatch => {
  const cnotes = [
    ...new Set((rows || []).map(r => r && r.documentId).filter(Boolean))
  ];
  if (!cnotes.length) return;

  dispatch({ type: documentCheckerActions.BULK_APPROVE_REQUEST });

  const finish = () => {
    if (cb) cb();
  };

  mapWithConcurrency(
    cnotes,
    EXTRACTION_FETCH_CONCURRENCY,
    fetchExtractionForCnote
  )
    .then(extractions => {
      const eligibleIds = extractions
        .filter(
          e =>
            e &&
            e.validationOutcome === VALIDATION_OUTCOME.ACCEPTED &&
            e.confidenceScore != null &&
            Number(e.confidenceScore) >= Number(threshold)
        )
        .map(e => e.extractionResultId)
        .filter(Boolean);

      if (!eligibleIds.length) {
        // Nothing to do — clear the in-progress flag and tell the reviewer why.
        dispatch({
          type: documentCheckerActions.BULK_APPROVE_SUCCESS,
          payload: 0,
          meta: { ids: [] }
        });
        toastr.light('Bulk approve', 'No high-confidence PODs to approve');
        finish();
        return null;
      }

      return mapWithConcurrency(
        eligibleIds,
        EXTRACTION_FETCH_CONCURRENCY,
        approveOneExtraction
      ).then(results => {
        const approvedIds = results.filter(r => r.ok).map(r => r.id);
        const failed = results.filter(r => !r.ok);
        const skippedCount = failed.length;
        // A representative reason for the skipped PODs (typically all the same
        // cause — out-of-OU or ineligible).
        const reasonCode = (failed.find(f => f.errorCode) || {}).errorCode;
        const skipReason =
          BULK_APPROVE_ERROR_MESSAGES[reasonCode] ||
          'not eligible or outside your delivery OU';

        if (approvedIds.length) {
          dispatch({
            type: documentCheckerActions.BULK_APPROVE_SUCCESS,
            payload: approvedIds.length,
            meta: { ids: approvedIds }
          });
          toastr.success(
            'Bulk approve',
            skippedCount
              ? `${approvedIds.length} POD(s) approved, ${skippedCount} skipped (${skipReason})`
              : `${approvedIds.length} POD(s) approved`
          );
        } else {
          const message =
            BULK_APPROVE_ERROR_MESSAGES[reasonCode] ||
            'No PODs were approved — they may be outside your delivery OU or no longer eligible.';
          dispatch({
            type: documentCheckerActions.BULK_APPROVE_FAILURE,
            payload: message
          });
          toastr.error('Bulk approve', message);
        }
        finish();
      });
    })
    .catch(() => {
      dispatch({
        type: documentCheckerActions.BULK_APPROVE_FAILURE,
        payload: 'Network error'
      });
      toastr.error('Bulk approve', 'Network error');
      finish();
    });
};
